import React from 'react';

/*
 *  @Description:   Stateless component that renders a Play icon.
 */

const Stream = ( props ) => {

    return (<g id="path">
            <polygon points="23 7 16 12 23 17 23 7"/>
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
        </g>
    )

};

export default Stream;

